import { put, takeEvery, select, delay } from 'redux-saga/effects'

import { Game } from '../../Core'

import * as actions from './toast.actions'
import * as selectors from './toast.selectors'

import BasicToast from './BasicToast'

/**
 *  Toast module init.
 */
export function* init() {
  yield loadComponents()
}

/**
 *  Load documents components.
 */
function* loadComponents() {
  const components = {
    BasicToast,
  }

  yield put(Game.actions.registerComponents(components))
}

function* deleteToast() {
  const delayTime = 1500
  const toastProps = yield select(selectors.getToastProps)

  if (toastProps) {
    yield delay(delayTime)
    yield put(actions.addToast())
  }
}

/**
 *  toast sagas entrypoint
 */
export function* sagas() {
  yield init()
  yield takeEvery(actions.ADD_TOAST, deleteToast)
}
